import React from 'react'

const LiftConfiguratorButton = ({ label, selected, onClick }) => (
  <div>
    <button
      type="button"
      onClick={onClick}
      className={`u-navi px-2.5 py-1 border transition-all rounded hover:text-black ${
        selected ? 'border-black text-black' : 'border-transparent text-gray-5'
      }`}
    >
      {label}
    </button>
  </div>
)

export default LiftConfiguratorButton
